import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { fetchUserHistoryApi } from "../../../services/Admin Portal/fetchUserHistoryApi";
import { TiArrowBack } from "react-icons/ti";
import { DataProvider } from '../../../store/ContextProvider';

export const LogHistory = () => {
  const { BeURL } = useContext(DataProvider)

  const [logHistory, setLogHistory] = useState(null);
  const { id } = useParams()

  const [currentPage, setCurrentPage] = useState(1)
  // const rowsPerPage = 15
  const [rowsPerPage, setRowsPerpage] = useState(10)
  const [totalPage, setTotalPage] = useState(0)
  const [totalSessionLogs, setTotlaSessionLogs] = useState(0)


  useEffect(() => {

    if (currentPage <= totalPage || totalPage === 0) {
      fetchUserHistoryApi(BeURL, setLogHistory, currentPage, rowsPerPage, setTotlaSessionLogs, setTotalPage, id)
    }
    else {
      setCurrentPage(1)
    }


  }, [currentPage, rowsPerPage, BeURL]);



  useEffect(() => {
    setCurrentPage(1)
  }, [rowsPerPage])

  const handlePagination = (dir) => {
    if (dir === 'prev' && currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
    if (dir === 'next' && currentPage < totalPage) {
      setCurrentPage(prev => prev + 1);
    }
  };

  return (
    <div className="min-h-[75vh] p-4">

     <h2 className='text-center text-2xl mt-4 font-semibold uppercase text-primary-500'>Logs history</h2>
      <p className="text-sm  text-center text-gray-500">
        Track login and logout activities of this user.
      </p>

      {/* Heading */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-5 gap-3">
        <div className="flex flex-col gap-1">
          <div onClick={() => window.location.href = '/session-logs'} className="flex items-center gap-1 text-white bg-slate-500 w-fit px-3 rounded-lg cursor-pointer hover:bg-slate-700">
            <TiArrowBack className="text-lg" />
            <span>Back</span>
          </div>
          {/* <div>
            <h2 className="text-lg font-semibold">User Login / Logout Histories</h2>


            <p className="text-sm text-gray-500">
              Track login and logout activities of this user.
            </p>
          </div> */}
        </div>
        <div>
          {
            logHistory?.map((log, idx) =>
            (
              <div>
                <p className="mt-2 text-md font-semibold text-primary-700 ">
                  Name :
                  <span className="mt-2 text-md font-semibold text-primary-400 hover:text-primary-600 cursor-pointer" onClick={()=>window.open(`/user/${log._id}`, "_blank")}> {log.fullName || ""} </span>
                </p>

                <p className="mt-2 text-md font-semibold text-primary-700 ">
                  Email :
                  <span className="mt-2 text-md font-semibold text-primary-400 hover:text-primary-600 cursor-pointer" onClick={()=>window.open(`/user/${log._id}`, "_blank")}> {log.email || "-"} </span>
                </p>

                <p className="mt-2 text-md font-semibold text-primary-700 ">
                  Contact Number :
                  <span className="mt-2 text-md font-semibold text-primary-400 hover:text-primary-600 cursor-pointer" onClick={()=>window.open(`/user/${log._id}`, "_blank")}> {log.contact || "-"} </span>
                </p>
              </div>
            ))
          }

        </div>
      </div>


      <div className="overflow-auto min-h-[55vh] bg-white rounded-xl shadow-md">
        {/* Header */}
        <table className="w-full text-left border-collapse">
          <thead className="bg-primary-500 text-white">
            <tr className='h-12 flex justify-around min-w-full items-center'>
              <td>Sl.No</td>
              <td>Status</td>
              <td>Clock In / out</td>
              <td>Date</td>
            </tr>
          </thead>
          <tbody>
            {logHistory?.length > 0 ? (
              logHistory.map((log, idx) =>
                log.data.map((session, sIdx) => (
                  <tr
                    key={session._id || `${idx}-${sIdx}`}
                    className="h-12 flex justify-around min-w-full  items-center border-b-[0.1px]  py-2 hover:bg-blue-50 border-b-gray-100"
                  >
                    {/* Serial Number */}
                    <td>
                      {sIdx + 1}
                    </td>

                    {/* Status */}
                    <td className={`${session.status === 'in' ? 'text-green-600' : "text-red-600"}`}>
                      {session.status}
                    </td>

                    {/* Time */}
                    <td>
                      {session.createdAt
                        ? new Date(session.createdAt).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        })
                        : "-"}
                    </td>

                    {/* Date */}
                    <td>
                      {session.createdAt
                        ? new Date(session.createdAt).toLocaleDateString([], {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                        : "-"}
                    </td>
                  </tr>
                ))
              )) : (
              <div className="flex justify-center items-center h-48">
                <td className="text-gray-500">No session logs available.</td>
              </div>
            )}
          </tbody>
        </table>
      </div>

      <div>

        {/* Pagination Controls */}
        <div className=" mx-auto my-3 flex justify-around items-center">
          <div className="flex items-center gap-2">
            <label htmlFor="recordsPerPage" className="text-sm">Records per page:</label>
            <select
              id="recordsPerPage"
              value={rowsPerPage}
              onChange={e => setRowsPerpage(parseInt(e.target.value, 10))}
              className="ml-2 px-3 py-1 border rounded"
            >
              {[10, 20, 25, 50, 75, 100].map(n => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>
          <div className="text-sm">Total Session Logs: {totalSessionLogs}</div>
        </div>

        <div className="flex justify-center items-center gap-4">

          <span className={`p-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === 1 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            onClick={() => handlePagination('prev')}
            disabled={currentPage === 1}
          >
            chevron_left
          </span>

          <span>{currentPage} of {totalPage}</span>

          <span className={`p-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === totalPage ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            onClick={() => handlePagination('next')}
            disabled={currentPage === totalPage}
          >
            chevron_right
          </span>

        </div>
      </div>
    </div>
  )
}



// import React, { useContext } from "react";
// import { DContext } from "../../../context/Datacontext";


// export const LogHistory = () => {
//     const { logHistory } = useContext(DContext);

//     const dates = logHistory ? Object.entries(logHistory) : [];

//     return (
//         <div className="w-full min-h-[80vh] mx-auto py-8 px-4 sm:px-8 md:px-20 lg:px-52">
//             {/* Heading */}
//             <div className="flex justify-between items-center mb-6">
//                 <div>
//                     <h2 className="text-lg font-semibold">User Login / Logout Histories</h2>
//                     <p className="text-sm text-gray-500">
//                         Track login and logout activities of this user.
//                     </p>
//                 </div>
//             </div>

//             {dates.length > 0 ? (
//                 <div className="space-y-6">
//                     {dates.map(([date, dayData], dIdx) => (
//                         <div key={date} className="border rounded-lg shadow p-4">
//                             {/* Date heading */}
//                             <div className="flex justify-between items-center mb-3">
//                                 <h3 className="font-semibold text-md">{date}</h3>
//                                 <span className="text-sm text-gray-600">
//                                     Total Hours: {dayData.totalHours}
//                                 </span>
//                             </div>

//                             {/* Table header */}
//                             <div className="bg-fuchsia-50 rounded-[3px] h-[48px] flex items-center text-gray-600 sticky top-0 z-1">
//                                 <p className="px-4 py-2 text-center font-medium w-1/4">Sl.No</p>
//                                 <p className="px-4 py-2 text-center font-medium w-1/4">Clock In</p>
//                                 <p className="px-4 py-2 text-center font-medium w-1/4">Clock Out</p>
//                                 <p className="px-4 py-2 text-center font-medium w-1/4">Hours Worked</p>
//                             </div>

//                             {/* Sessions */}
//                             <div className="space-y-1">
//                                 {dayData.sessions.map((session, sIdx) => (
//                                     <div
//                                         key={sIdx}
//                                         className="bg-gray-50 rounded-[3px] h-[48px] flex items-center"
//                                     >
//                                         <p className="px-4 py-2 text-center w-1/4">{sIdx + 1}</p>
//                                         <p className="px-4 py-2 text-center w-1/4">{session.in}</p>
//                                         <p className="px-4 py-2 text-center w-1/4">{session.out}</p>
//                                         <p className="px-4 py-2 text-center w-1/4">{session.hoursWorked}</p>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             ) : (
//                 <div className="flex justify-center items-center h-48">
//                     <p className="text-gray-500">No session logs available for this user.</p>
//                 </div>
//             )}
//         </div>
//     );
// };
